<template>
  <div class="main-content item-create">
    <div class="page-header">
      <h3 class="page-title">{{ isEdit ? $t('islamic_finance.edit_finances_forms') : $t('islamic_finance.new_finances_forms') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link  slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/finances-forms">{{ $tc('islamic_finance.finances_forms',2) }}</router-link></li>
        <li class="breadcrumb-item"><a href="#"> {{ isEdit ? $t('islamic_finance.edit_finances_forms') : $t('islamic_finance.new_finances_forms') }}</a></li>
      </ol>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <form action="" @submit.prevent="submitFinancesForms">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $tc('islamic_finance.funder_list',2) }}</label>
                    <base-select
                      v-model="formData.funder_id"
                      :options="funders"
                      :searchable="true"
                      :show-labels="false"
                      :placeholder="$t('funders.select_a_funder')"
                      label="name"
                      track-by="id"
                    >
                    </base-select>
                    <div v-if="$v.formData.funder_id.$error">
                      <span v-if="!$v.formData.funder_id.required" class="text-danger">
                        {{ $tc('validation.required') }}
                      </span>
                    </div>
                  </div>
                </div>
                 <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $t('islamic_finance.forms') }}</label>
                    <!-- <base-select
                      v-model="formData.form"
                      :options="forms"
                      :searchable="true"
                      :show-labels="false"
                      :placeholder="$t('islamic_finance.select_a_form')"
                      label="name"
                      track-by="label"
                    >
                    </base-select> -->
                    <select v-model="formData.form" class="form-control">
                      <option v-for="frm in forms" :value="frm.label" :key="frm.label">{{ frm.name }}</option>
                    </select>
                    <div v-if="$v.formData.form.$error">
                      <span v-if="!$v.formData.form.required" class="text-danger">
                        {{ $tc('validation.required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="content">{{ $t('islamic_finance.content') }}</label>
                    <ckeditor :invalid="$v.formData.content.$error" @input="$v.formData.content.$touch()" :config="editorConfig" v-model="formData.content" class="editor-instance" />
                    <div v-if="$v.formData.content.$error">
                      <span v-if="!$v.formData.content.maxLength" class="text-danger">
                        {{ $t('validation.description_maxlength') }}
                      </span>
                    </div>
                  </div>
                  <div class="text-center">
                    <div class="form-group">
                      <base-button
                        :loading="isLoading"
                        :disabled="isLoading"
                        icon="save"
                        color="theme"
                        type="submit"
                        class="collapse-button m-auto"
                      >
                        {{ isEdit ? $t('islamic_finance.update_finances_forms') : $t('islamic_finance.save_finances_forms') }}
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, minLength, numeric, minValue, maxLength,alphaNum } = require('vuelidate/lib/validators')

export default {
  mixins: {
    validationMixin
  },
  data () {
    return {
      isLoading: false,
      title: 'Add Item',
      formData: {
        id:'',
        funder_id:'',
        form:'',
        content: '',
      },
      userType:null,
      forms:[
          {
            'id': 1,
            'name': 'Offer Sent',
            'label': 'offer_sent'
          },
          {
            'id': 2,
            'name': 'Offer Accepted',
            'label': 'offer_accepted'
          },
          { 'id': 3,
            'name': 'Notice of Delivery',
            'label': 'notice_of_delivery'
          },
          {
            'id': 4,
            'name': 'Documentation Complete',
            'label': 'documentation_complete'
          },
          {
            'id': 5,
            'name': 'Confirmation of Sale',
            'label': 'confirmation_of_sale'
          }
        ],
      funders:[],
      editorConfig: {
        extraPlugins : "justify"
      }
    }
  },
  computed: {
    isEdit () {
      if (this.$route.name === 'finances-forms.edit') {
        return true
      }
      return false
    }
  },
  created () {
    this.fetchData()
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    if (this.isEdit) {
      this.loadEditData()
    }
  },
  validations: {
    formData: {
      funder_id: {
        required,
      },
      form: {
        required
      },
      content: {
        required,
        // maxLength: maxLength(500)
      }
    }
  },
  methods: {
    ...mapActions('financesForms', [
      'addFinancesForm',
      'updateFinancesForm',
      'editFinancesForm',
      'createFinancesForm'
    ]),
    ...mapActions('customer', [
      'fetchCustomers',
    ]),
    async fetchData () {
      let response = await this.createFinancesForm()
      this.funders = response.data.accounts
    },
    async loadEditData () {
      let response = await this.editFinancesForm(this.$route.params.id)
      this.formData.id = response.data.financesForm.id
      this.formData.funder_id = response.data.financesForm.user

      const matchingOption = this.forms.find(option => option.label === response.data.financesForm.form);
      this.formData.form = matchingOption.label;

      this.formData.content = response.data.financesForm.content
    },
    // submit form
    async submitFinancesForms () {
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return false
        }
        let data = {
            id: this.formData.id,
            funder_id: this.formData.funder_id.id,
            form: this.formData.form,
            content: this.formData.content,
        }

        let alert
        let response
        if (this.isEdit) {
            this.isLoading = true
            response = await this.updateFinancesForm(data)
            alert = this.$tc('islamic_finance.update_content')
        } else {
            response = await this.addFinancesForm(data)
            alert = this.$tc('islamic_finance.add_content')
        }
        if (response.data.success) {
            this.isLoading = false
            window.toastr['success'](alert)

            if (response.data.funder_id) {
              this.$router.push('/super-admin/finances-forms/'+response.data.funder_id+'/view')
            } else {
              this.$router.push('/super-admin/finances-forms')
            }

            return true
        }
        window.toastr['error'](response.data.error)
    }
  }
}
</script>
